import { Box } from "@mui/material";
import Row from "components/templatesComponents/table/Row";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const Table = (props) => {
  const { body, header, isActiveHeader, multiline, bordered, noScroll, colSize, title = "" } = props;

  const bo = useMemo(() => typeof title === "object", [title]);

  let classNames = "";

  const bodyRows = useMemo(() => {
    if (!Array.isArray(body.rows)) {
      return [body.rows];
    }
    return body.rows;
  }, [body]);

  if (bodyRows.length === 0) {
    return null;
  }

  if (noScroll) {
    classNames += " fr-table--no-scroll";
  }

  if (bordered) {
    classNames += " fr-table--bordered";
  }
  if (multiline) {
    classNames += " fr-table--multiline";
  }

  if (!title) {
    classNames += " fr-mt-n6w";
  }

  switch (colSize) {
    case "sm":
      classNames += " fr-table--sm";
      break;
    case "lg":
      classNames += " fr-table--lg";
      break;
    default:
      break;
  }

  return (
    <div className={`fr-table${classNames}`}>
      <div className="fr-table__wrapper">
        <div className="fr-table__container">
          <div className="fr-table__content">
            <table>
              {title && <caption>{title}</caption>}
              {(bo || isActiveHeader) && (
                <Box component="thead" sx={bo ? { opacity: isActiveHeader ? 1 : 0.3 } : {}}>
                  <Row {...header.rows} isHeader />
                </Box>
              )}
              <tbody>
                {bodyRows.map((row) => (
                  <Row {...row} key={`row-${row.id}`} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

Table.propTypes = {
  body: PropTypes.shape(),
  header: PropTypes.shape(),
  rows: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  multiline: PropTypes.bool,
  noScroll: PropTypes.bool,
  isActiveHeader: PropTypes.bool,
  bordered: PropTypes.bool,
  colSize: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
};

export default Table;
